import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const PlaybookSection = () => {
  const navigate = useNavigate();

  return (
    <section data-testid="playbook-section" className="relative py-20 lg:py-28 bg-[#0B0D10]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-[720px]">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#F2F4F7] leading-tight tracking-tight mb-8">
            The Playbook Is No Longer Locked Behind a Studio Door.
          </h2>

          <div className="space-y-6 text-base text-[#A6AFBD] leading-relaxed mb-10">
            <p>
              For decades, fully developing an IP — the character bibles, the pitch decks, the visual world-building — required a budget most independent creators will never see. The tools existed. The knowledge existed. But access didn't.
            </p>
            <p className="text-[#F2F4F7] font-medium">
              That's over.
            </p>
            <p>
              AI has democratized the entire development pipeline. What used to cost $50K-$100K in team overhead can now be done by a single creator with the right tools, the right workflow, and the insider knowledge of how Hollywood actually packages and sells IP.
            </p>
            <p>
              I've spent 15 years inside that machine — producing, pitching, and selling. I've taken everything I know and built it into a course designed for the creator who is just starting out. No massive budget. No industry connections. No team.
            </p>
            <p>
              Just your idea, the right tools, and a proven system to take it from concept to pitch-ready — before you ever need to raise a dollar or hire a single person.
            </p>
          </div>

          <button
            data-testid="playbook-cta-button"
            onClick={() => navigate('/ai-tools-for-creatives')}
            className="group inline-flex items-center gap-3 bg-[#3B82F6] text-white px-7 py-4 text-base font-medium transition-all duration-300 hover:bg-[#2563EB] hover:scale-[1.02] hover:shadow-lg hover:shadow-[#3B82F6]/25"
          >
            Enter the Classroom
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default PlaybookSection;
